import React, { useEffect, useMemo, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import CmsAPI from '../../../common/apis/CmsAPI';
import VideoService from '../../service/VideoService';

const AssistantPage = () => {
  const location = useLocation();
  const id = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get('id');
  }, [location.search]);
  const [redirectLink, setRedirectLink] = useState(/** @type {string} */ null);
  useEffect(() => {
    let ignore = false;

    async function loadAssistantPage() {
      let link = '/eg/home';
      if (id) {
        const isLoggedIn = await CmsAPI.isLoggedIn();
        if (isLoggedIn) {
          try {
            const { id: storyId } = await VideoService.createFromTemporaryStory(id);
            localStorage.removeItem('typebot-id');
            link = `/eg/storyboard/${storyId}`;
          } catch (e) {
            console.error(e);
          }
        } else {
          localStorage.setItem('typebot-id', id);
        }
      }
      if (!ignore) {
        setRedirectLink(link);
      }
    }

    loadAssistantPage();
    return () => {
      ignore = true;
    };
  }, [id]);

  if (!redirectLink) {
    return null;
  }
  return <Redirect to={redirectLink} />;
};

export default AssistantPage;
